import axiosClient from "./axiosClient";

class TransactionFee {
    constructor() {
        this.api_url = "/api/transactions-fee";
    }

    async getAll(credentials) {
        return await axiosClient.get(this.api_url, {
            params: {
                page: credentials.page,
                perPage: credentials.perPage
            },
        });
    }

    async getReport() {
        return await axiosClient.get(this.api_url+'/report');
    }

}

export default new TransactionFee;